export default __webpack_public_path__ + "static/media/tools-bj-bottom.8cac9ad5.png";